import ReactComponent from '../app/ReactComponent'

export default class GuideOverviewPage extends ReactComponent {
  render() {
    return (
      <>
      </>
    )
  }
}